// libs
import { useState } from "react";
import { Edit2, Trash2 } from "lucide-react";

// components
import CustomButton from "../CustomButton";
import ProductEditModal from "../ProductEditModal";

// custom hooks
import useToken from "../../hooks/useToken";
import useProducts from "../../hooks/useProducts";
import useAlert from "../../hooks/useAlert";

// utils
import API from "../../utils/api";

// styles
import classes from "./styles.module.css";

export default function Product({ data }) {
  const { id, title, purchase_price, selling_price, count } = data;
  const [isInProcess, setIsInProcess] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [token] = useToken();
  const { delProduct } = useProducts();
  const { createAlert } = useAlert();

  const openModal = () => {
    setIsOpenModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpenModal(false);
    document.body.style.overflow = "auto";
  };

  const onEdit = () => {
    openModal();
  };

  const onDelete = () => {
    if (window.confirm(`Удалить "${title}" ?`)) {
      setIsInProcess(true);
      API.deleteToken(`/products/${id}`, token).then((d) => {
        if (d?.status === 204) {
          setIsInProcess(false);
          delProduct(id);
          createAlert.success("Товар удален");
        } else {
          createAlert.error(d.message ?? "Не удалось удалить товар");
        }
      });
    }
  };

  return (
    <>
      <div className={`${classes.root} ${isInProcess && classes.isInProcess}`}>
        <div className={classes.header}>
          <p
            className={`${classes.count} ${count === 0 ? classes.countEmpty : count <= 5 && classes.countLow}`}
          >
            {count > 0 ? `${count} шт.` : "нет в наличии"}
          </p>
          <div className={classes.buttons}>
            <CustomButton
              onClick={onEdit}
              className={`${classes.button} ${classes.edit}`}
            >
              <Edit2 size={14} />
            </CustomButton>
            <CustomButton
              onClick={onDelete}
              className={`${classes.button} ${classes.delete}`}
            >
              <Trash2 size={14} />
            </CustomButton>
          </div>
        </div>

        <div className={classes.titleContainer}>
          <p className={classes.title}>{title}</p>
        </div>

        <div className={classes.infoContainer}>
          <div className={classes.info}>
            <p className={classes.infoTitle}>Закупка</p>
            <p className={classes.infoValue}>{purchase_price} ֏</p>
          </div>

          <div className={classes.info}>
            <p className={classes.infoTitle}>Продажа</p>
            <p className={classes.infoValue}>{selling_price} ֏</p>
          </div>

          <div className={classes.info}>
            <p className={classes.infoTitle}>
              Маржа(
              {Math.floor(
                (100 * (selling_price - purchase_price)) / selling_price,
              )}
              %)
            </p>
            <p className={classes.infoValue}>
              +{selling_price - purchase_price} ֏
            </p>
          </div>
        </div>
      </div>

      {isOpenModal && (
        <ProductEditModal productCurrentData={data} closeModal={closeModal} />
      )}
    </>
  );
}
